import { PopupContentProps } from "../Common/Elements/Popup";
import './ShareLytAdminPopup.css'
import { useTranslation } from "react-i18next";
import { useContext, useEffect, useRef, useState } from "react";
import { NotificationsContext } from "../../App";
import { formatBalanceNumber } from "../../communication/format";
import { Button } from "../Common/Elements/Button";
import { LoadingCircle } from "../Common/Loading/LoadingPlaceholder";
import { loading } from "../../communication/wrapped";
import { Wallet } from "../../types/explyt";
import { getWallets, postWithdraw } from "../../communication/communication";
import { SetBalanceContext } from "../Common/Authorization/UserProvider";
//import { Scanner } from '@yudiel/react-qr-scanner'
import {
    useScanQrPopup,
} from '@vkruglikov/react-telegram-web-app';


const scanIcon = <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3 8V5C3 3.89543 3.89543 3 5 3H8M3 16V19C3 20.1046 3.89543 21 5 21H8M16 21H19C20.1046 21 21 20.1046 21 19V16M16 3H19C20.1046 3 21 3.89543 21 5V8" stroke="#6D6D6D" strokeWidth="2" strokeLinecap="square" />
    <path d="M7 12H17" stroke="#6D6D6D" strokeWidth="2" strokeLinecap="square" />
</svg>

function TransferInput({ upperLimit, setInput }: { upperLimit: number, setInput: (_: number) => void }) {
    const [value, setValue] = useState("0");
    const inputRef = useRef(null!);

    useEffect(() => {
        const matches = value.match(/(\d+)/g);

        // Display output if number extracted
        if (matches) {
            const str = matches.reduce((e, a) => e + a)
            console.log(str)
            setValue(formatBalanceNumber(+str.slice(0, 9), 0));
        }
    }, [value]);

    const mask = <input
        autoFocus
        ref={inputRef}
        inputMode="numeric"
        className="transfer-input"
        style={{ width: `0rem` }}
        value={value}
        onChange={e => { setValue(e.target.value) }}
    />

    const displayValue = value !== "" ? value : "0"
    const number = +displayValue.replace(",", "");

    useEffect(() => {
        const n = +(value !== "" ? value : "0").replace(",", "");
        setInput(n);
    }, [value, setInput]); // eslint-ignore-line

    return <div className="flex-row small-gap" onClick={() => (inputRef.current as HTMLInputElement).focus()}>
        {mask}
        <span className="transfer-input text-center" style={{ color: displayValue === "0" ? "var(--font-dim)" : number <= upperLimit ? "white" : "var(--color-red)" }}> {displayValue} Test Credits </span>
    </div>
}

export function ProcessQrCode(data: any) {
    const TMA = (window as any).Telegram.WebApp;
    TMA.closeScanQrPopup();

    const addNotification = useContext(NotificationsContext);
    addNotification(data.data);
}

function UserAccountSearch() {
    const { t } = useTranslation();
    const [username, setUsername] = useState("")
    const [amount, setAmount] = useState(0)
    const addNotification = useContext(NotificationsContext);
    const [wallets, setWallets] = useState(loading<Wallet[]>(null!));
    const setBalance = useContext(SetBalanceContext);
    const [showQrPopup, closeQrPopup] = useScanQrPopup();

    useEffect(() => {
        getWallets().then(setWallets);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    if (wallets.statusCode !== 200) {
        return <div className="full-size flex-center">
            <LoadingCircle className="loading-circle-big" />
        </div>
    }

    const tryOpenQr = () => {
        try {
            showQrPopup({text: ""}, text => {
                closeQrPopup();

                let userId = text;
                let indexOfEq = text.indexOf("=");
                if (indexOfEq !== -1) {
                    userId = text.substring(indexOfEq);
                }
                addNotification(userId)

            })
        } catch (e) {
            addNotification(t("errorOccurred"))
            closeQrPopup()
        }
    }

    const balance = wallets.data!.find(w => w.currency === "Credits")!.balance;

    const input = <input type="text" className="user-account-search-input" placeholder={t("account")} onChange={e => setUsername(e.target.value)} />
    const scan = <div className="flex-center" onClick={tryOpenQr}>
        {scanIcon}
    </div>

    const transfer = () => {
        postWithdraw("", username, amount).then(r => {
            if (r.statusCode !== 200) {
                addNotification(r.errorMessage?.code!)
                return;
            }
            setBalance(r.data!)
        })
    }

    const canTransfer = amount <= balance && amount > 0;

    return <div className="small-margin small-padding-top full-high" style={{ display: "grid", gridTemplateRows: "4rem 1fr 9rem" }}>
        <div className="user-account-search flex-y-center">
            {input}
            {scan}
        </div>
        <div className="flex-center full-size">
            <TransferInput upperLimit={balance} setInput={setAmount} />
        </div>
        <div className="flex-column small-gap">
            <div className="flex-center">
                <span className="medium-font font-gray" style={{ color: amount <= balance ? "var(--font-dim)" : "var(--color-red)" }}> {t("balance")}: {formatBalanceNumber(balance)} Test Credits</span>
            </div>
            <Button
                onClick={canTransfer ? transfer : () => { }}
                textColor={canTransfer ? "black" : "var(--font-dim)"}
                backgroundColor={canTransfer ? "var(--color-main)" : "var(--progress-bar-button-bg)"}
                text={t("send")}
            />
        </div>
    </div>
}

function ShareLytAdmin() {
    return <UserAccountSearch />
}

export function ShareLytAdminPopup(props: PopupContentProps<{}>) {
    return <div className={props.isOpen ? "bg-black" : "hidden"}>
        <ShareLytAdmin {...props.data} />
    </div>
}